<template>
		<img ref="imgRef" :src=bldgPhoto width='100%' class="mt-2" style="display: block" @error="imgHandler" onLoad="style.visibility='visible'">
</template>

<script>
import { mapState, mapMutations } from 'vuex'

let BldgPhoto = {
	name: BldgPhoto,
	data() {
		return {
		}
	},

	computed: {
		...mapState({
			bldgPhoto: state => state.space.selectedBuilding.photoURLMedium
	  	}),
	},

	methods: {
	    imgHandler: function (e) {
	    	this.$refs.imgRef.style.visibility = "hidden"
	    	console.log("Image Error")
	    },

	},

}

export default BldgPhoto

</script>

<style>
</style>





// WEBPACK FOOTER //
// src/components/buildingcard/BldgPhoto.vue